import React from "react";
import { AuthContainer, AuthWrapper, CompanyName, PortalSubtitle, FormCard, FormTitle, FormSubtitle } from "./index.styles";

const PortalInactive = ({ name }) => {
  return (
    <AuthWrapper>
      <AuthContainer>
        <CompanyName>{name || "Company Name"}</CompanyName>
        <PortalSubtitle>B2B Customer Portal</PortalSubtitle>
        <FormCard style={{ marginTop: "24px" }}>
          <FormTitle>Portal Inactive</FormTitle>
          <FormSubtitle>
            This portal is currently inactive. Please contact the administrator for more information.
          </FormSubtitle>
        </FormCard>
      </AuthContainer>
    </AuthWrapper>
  );
};

export default PortalInactive;
